<template>
  <div class="main-container">
    <div class="content-wrap">
      <img src="../../assets/images/wallet/ic_plaint.png" alt/>
      <p>该用户已经禁用，请联系管理员</p>
      <span @click="back">退出</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Disabled',
  methods: {
    back() {
      this.$JD.goBack()
    }
  }
}
</script>

<style lang="scss">
.main-container {
  font-family: SourceHanSansCN-Normal;

  .content-wrap {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    background-color: #f0f0f4;

    img {
      width: 1.7rem;
      height: 1.7rem;
    }

    p {
      padding: 0.5rem;
      color: #8b8b8b;
      font-size: 0.187rem;
      text-align: center;
    }

    span {
      font-size: 0.26rem;
      color: #8B8B8B;
      padding: 0.04rem 0.6rem;
      border-width: 1px;
      border-style: solid;
      border-color: #8B8B8B;
      border-radius: 0.3rem;

    }
  }
}
</style>
